<template>
  <div>
    <vx-card class="mb-4">
      <div class="flex justify-between">
        <div class="flex items-center">
          <div class="h-10 w-10 flex justify-center items-center rounded-lg mr-3 "
               :style="`background: #${color}`">
            <feather-icon icon="VideoIcon" svgClasses="h-6 w-6"/>
          </div>
          <h3 class="font-bold">{{ name }}</h3>
        </div>
        <div class="flex items-center">
          <vs-button class="mr-3" :color="`#${color}`" icon="icon-link"
                     @click="openUrl" icon-pack="feather">Join Meeting
          </vs-button>
          <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>
            <feather-icon icon="MoreVerticalIcon" svgClasses="h-6 w-6"/>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="editMeeting">Edit</vs-dropdown-item>
              <vs-dropdown-item @click="confirmDeleteMeeting">Delete</vs-dropdown-item>
            </vs-dropdown-menu>

          </vs-dropdown>
        </div>
      </div>
      <div class="pt-3" v-if="description">
        <h5 class="font-light">{{ description }}</h5>
      </div>
    </vx-card>

    <vs-popup :active.sync="editPopup"  title="Edit Meeting">
      <div class="popup-input" v-if="meeting">
        <p class="mb-1 font-semibold">Name</p>
        <vs-input v-model="meeting.name" class="mb-3 w-full"/>

        <p class="mb-1 font-semibold">Description</p>
        <vs-input v-model="meeting.description" class="mb-3 w-full"/>

        <p class="mb-1 font-semibold">Meeting Url</p>
        <vs-input v-model="meeting.url" class="mb-3 w-full"/>

      </div>
    </vs-popup>

  </div>

</template>

<script>
export default {
  name: 'ClassroomMeetingCard',
  data () {
    return {
      editPopup: false,
      deletePopup: false,
      meeting: null
    }
  },
  props: {
    meetingId: {
      type: String
    },
    color: {
      type: String
    },
    name: {
      type: String
    },
    description: {
      type: String
    },
    url: {
      type: String
    }
  },
  methods: {
    confirmDeleteMeeting () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Please confirm you want to delete this meeting.',
        accept: this.deleteMeeting,
        acceptText: 'Delete'
      })
    },
    deleteMeeting () {
      this.$http.delete(`classrooms/meetings/${this.meetingId}`)
        .then(response => {
          if (response.data.data) {
            this.$emit('refresh')
            this.$vs.notify({
              title: 'Meeting Delete Successfully',
              text: 'Meeting has been deleted.',
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
        .catch(() => {
          this.$emit('refresh')
          return this.$vs.notify({
            title: 'Failed To Delete Meeting',
            text: 'An unknown error occurred while updating this meeting',
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    },
    editMeeting () {
      this.$http.get(`classrooms/meetings/${this.meetingId}`)
        .then(response => {
          if (response.status === 200) {
            this.meeting = response.data.data
            this.editPopup = true
          }
        })
    },
    openUrl () {
      if (!this.url) return
      window.open(this.url, '_blank')
    },
    updateMeeting () {
      this.$http.post(`classrooms/meetings/${this.meetingId}`, this.meeting)
        .then(response => {
          if (response.status === 200) {
            this.$emit('refresh')
            this.$vs.notify({
              title: 'Meeting Updated Successfully',
              text: `${this.meeting.name} has been updated.`,
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
        .catch(exception => {
          this.$emit('refresh')
          let error = 'An unknown error occurred while updating this meeting'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          this.$vs.notify({
            title: 'Failed To Update Meeting',
            text: error,
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    }
  },
  watch: {
    editPopup (val) {
      if (!val) this.updateMeeting()
    }
  }
}
</script>

